export const lifeCycleTypes = [
  { value: 1, label: 'None', date: false },
  { value: 2, label: 'Expiry Date', date: true },
  { value: 3, label: 'Shelf Life Days', date: false },
  { value: 4, label: 'After Open Days', date: false },
  { value: 5, label: 'Lifetime Hours', date: false },
  { value: 6, label: 'Lifetime Cycles', date: false },
]

export const lifeCycleStartSources = [
  { label: 'Manufacture Date', value: 1 },
  { label: 'Received At', value: 2 },
  { label: 'First Opened At', value: 3 },
  { label: 'First Installed At', value: 4 },
]

export const depreciationMethodOptions = [
  { value: 1, label: 'None' },
  { value: 2, label: 'Straight Line' },
  { value: 3, label: 'Declining Balance' },
]

export const costingMethodOptions = [
  { value: 1, label: 'FIFO' },
  { value: 2, label: 'LIFO' },
  { value: 3, label: 'Weighted Avgerage' },
  { value: 4, label: 'Standard' },
]

export const trackingModeOptions = [
  { value: 1, label: 'None' },
  { value: 2, label: 'Batch' },
  { value: 3, label: 'Lot' },
  { value: 4, label: 'Serial' },
]

export const expiryPolicyOptions = [
  { value: 1, label: 'None' },
  { value: 2, label: 'FEFO' },
  { value: 3, label: 'FIFO' },
]

export const itemInitialState = {
  category: null,
  image: null,
  unit: null,
  fieldValues: [],
  operations: [],
  name: null,
  sku: null,
  machineModels: [],
  preferredSupplier: null,
  costCenter: null,
  description: null,
  fields: [],

  lifecycleExpirationType: null,
  lifecycleNumericExpirationValue: null,
  lifecycleDateExpirationValue: null,
  lifecycleStartSourceType: null,
  lifecycleNumericStartSourceValue: null,
  lifecycleDateStartSourceValue: null,
  msdsAttachmentFileUrl: null,
  expiryPolicy: null,
  warrantyMonths: null,
  trackingMode: null,
  costingMethod: null,
  standardCost: null,
  minLevel: null,
  maxLevel: null,
  reorderPoint: null,
  leadTimeDays: null,
  hazardClass: null,
  glAssetCode: null,
  glExpenseCode: null,
  taxDeductible: false,
  depreciable: false,
  depreciationMethod: null,
  depreciationPeriodMonths: null,
  barcodes: [],
}
export const barCodeTypes = [
  { value: 1, label: 'EAN13' },
  { value: 2, label: 'EAN8' },
  { value: 3, label: 'UPC_A' },
  { value: 4, label: 'UPC_E' },
  { value: 5, label: 'CODE128' },
  { value: 6, label: 'CODE39' },
  { value: 7, label: 'QR' },
  { value: 8, label: 'DATAMATRIX' },
]
